var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsNumber, IsObject, IsString, IsUUID } from 'class-validator';
import { ExerciseLiteDto } from '../../exercise/dtos/exercise.lite.dto.js';
import { ExerciseDeviceFullSizeDto } from './exercise-device.full-size.dto.js';
export class ExerciseDeviceItemFullSizeDto {
    id;
    createdAt;
    updatedAt;
    exerciseId;
    count;
    exercise;
    exerciseDeviceId;
    exerciseDevice;
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], ExerciseDeviceItemFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ExerciseDeviceItemFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ExerciseDeviceItemFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ExerciseDeviceItemFullSizeDto.prototype, "exerciseId", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseDeviceItemFullSizeDto.prototype, "count", void 0);
__decorate([
    IsObject(),
    Type(() => ExerciseLiteDto),
    Expose(),
    __metadata("design:type", Function)
], ExerciseDeviceItemFullSizeDto.prototype, "exercise", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ExerciseDeviceItemFullSizeDto.prototype, "exerciseDeviceId", void 0);
__decorate([
    IsObject(),
    Type(() => ExerciseDeviceFullSizeDto),
    Expose(),
    __metadata("design:type", ExerciseDeviceFullSizeDto)
], ExerciseDeviceItemFullSizeDto.prototype, "exerciseDevice", void 0);
//# sourceMappingURL=exercise-device-item.full-size.dto.js.map